'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    IndexOpenDataController.$inject = ['$q', '$translate', 'ckanService'];
    angular.module('app.open-data').component('indexOpenData', {
        require: { app: '^app' },
        template: '<div style="padding: 2em 2em;" translate-namespace="open-data"><div class="container"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label}}</a></li><li translate>.Municipal open data</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-lg-4"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="icon-city" aria-hidden="true"></i> <a ui-sref="municipal-roll" translate>.Municipal Roll</a></div></div></div><div class="col-lg-4"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="icon-baby" aria-hidden="true"></i> <a ui-sref="civil-register" translate>.Civil Register</a></div></div></div><div class="col-lg-4"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="fa fa-money" aria-hidden="true"></i> <a ui-sref="fiscal-data" translate>.Fiscal data</a></div></div></div><div class="col-lg-4"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="fa fa-book" aria-hidden="true"></i> <a ui-sref="library" translate>.Library</a></div></div></div><div class="col-lg-4"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="fa fa-users" aria-hidden="true"></i> <a ui-sref="social-service" translate>.Social service</a></div></div></div></div><div class="row"><div class="col-lg-12"><h2 translate>.Datasets</h2></div><div class="col-lg-4" ng-repeat="dataset in $ctrl.datasets"><div class="panel panel-default panel-dial"><div class="panel-body"><a href="{{dataset[$ctrl.translations[\'open-data.dataset-url-attr\']]}}">{{dataset[$ctrl.translations[\'open-data.dataset-name-attr\']]}}</a></div></div></div></div></div></div>',
        controller: IndexOpenDataController,
        controllerAs: '$ctrl'
    });

    function IndexOpenDataController($q, $translate, ckanService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $q.all({
                datasets: ckanService.getDatasets(),
                translations: getTranslations()
            }).then(function (results) {
                $ctrl.translations = results.translations;
                $ctrl.datasets = results.datasets;
            });
        };

        /**
         * 
         */
        function getTranslations() {
            return $translate(['open-data.dataset-name-attr', 'open-data.dataset-url-attr']);
        }
    }
})();